import { render, staticRenderFns } from "./StoryViewer.vue?vue&type=template&id=dbcc60ae&scoped=true"
import script from "./StoryViewer.vue?vue&type=script&lang=js"
export * from "./StoryViewer.vue?vue&type=script&lang=js"
import style0 from "./StoryViewer.vue?vue&type=style&index=0&id=dbcc60ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcc60ae",
  null
  
)

export default component.exports